import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'

const UserHeaderLimitedEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '200px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="User Header" />}
        >
            <div>
                <div  className="uiEditableContent" id="editor">
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl"><SarasTrans value = "User ID"/></span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "userId" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "title" }} value="Title" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "title" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "firstName" }} value="First Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "firstName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "middleName" }} value="Middle Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "middleName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastName" }} value="Last Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "lastName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "nickName" }} />
                            </li>
                        </ul>
                    </div>
                    <div className="uiCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email1" }} value="Email 1" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "email1" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "mobile1" }} value="Mobile 1" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "input", paramName: "mobile1" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "svLoginId" }} value="Login ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "svLoginId" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "userPass" }} value="Password" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal" gid="full" autocomplete="off"
                                action={{ InputType: "password", paramName: "userPass" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "language" }} value="Default Language" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal"
                                action={{ InputType: "ac", paramName: "language", acMethod: "ActiveCulture" }} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </FormDialog>
    )
}

export default withView(UserHeaderLimitedEditor, "userHead", "userHead")